import React from 'react';
import { ACCESS_STEPS } from '../../data/catio';
export function AccessSection() {
  return <section aria-labelledby="access-title" className="bg-stone py-12 sm:py-16" data-id="element-119" data-mp="3epk6tfw4erga">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-120" data-mp="3sgffar2pj6jc">
        <h2 id="access-title" className="font-display text-[1.8rem] leading-[1.12] text-ink sm:text-[2.4rem]" data-id="element-121" data-mp="3sfnlnlso7ivp">
          Access Your Plan Library Immediately After Purchase
        </h2>
        <ol className="mt-6 grid gap-px overflow-hidden rounded-[14px] border border-line bg-line sm:grid-cols-2 lg:grid-cols-4" data-id="element-122" data-mp="30rdgqlxexvr6">
          {ACCESS_STEPS.map((step, index) => <li key={step} className="flex items-center gap-4 bg-paper px-5 py-4 lg:flex-col lg:items-start lg:gap-3 lg:py-6" data-id="element-123" data-mp="39rijujvkq7zj" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-ember font-tech text-[15px] font-semibold text-ember" data-id="element-124" data-mp="oyx7ukquk1jg">
                {index + 1}
              </span>
              <span className="text-[1rem] font-medium leading-snug text-ink" data-id="element-125" data-mp="1cot4wwpbqqk6">{step}</span>
            </li>)}
        </ol>
      </div>
    </section>;
}